import React from 'react'
import { observer } from 'mobx-react-lite'

import {
  Loader,
  MiniWidgetContainer,
  useAccountStore,
  useCategoryStore,
  useGlobalCopyStore,
  useGlobalStore,
  useGlobalUiStore,
  useWidgetLoadTimer,
} from '../common'
import { MiniWidgetProps } from '../core'

import SpendingChart from './components/SpendingChart'

const TrendsMiniWidget: React.FC<MiniWidgetProps> = ({ onPrimaryCtaClick, sx }) => {
  const { isAccountDataLoaded, loadAccountData } = useAccountStore()
  const { loadMonthlyCategoryTotals, monthlyTotalsLoaded } = useCategoryStore()
  const { isInitialized } = useGlobalStore()
  const { trends: trendsCopy } = useGlobalCopyStore()
  const { selectedAccounts } = useGlobalUiStore()

  React.useEffect(() => {
    if (!isAccountDataLoaded) {
      loadAccountData().finally()
    }
  }, [])

  useWidgetLoadTimer({
    widgetName: 'TrendsMiniWidget',
    isLoaded: monthlyTotalsLoaded,
  })

  React.useEffect(() => {
    if (isInitialized && isAccountDataLoaded) {
      loadMonthlyCategoryTotals(selectedAccounts).finally()
    }
  }, [isAccountDataLoaded, isInitialized, selectedAccounts])

  if (!isAccountDataLoaded || !isInitialized || !monthlyTotalsLoaded) {
    return <Loader />
  }

  return (
    <MiniWidgetContainer
      contentStyles={{ height: 'calc(100% - 72px)', minHeight: 300, ':last-child': { pb: 0 } }}
      onPrimaryCtaClick={onPrimaryCtaClick}
      primaryCtaLabel={trendsCopy.primary_cta}
      subTitle={trendsCopy.sub_title}
      sx={{ height: '100%', ...sx }}
      title={trendsCopy.mini_title}
    >
      <SpendingChart />
    </MiniWidgetContainer>
  )
}

export default observer(TrendsMiniWidget)
